// Homepage category tiles: crossfade through the product photos rendered by
// sections/dt-subcategory-tiles.liquid. Every photo ships with data-src only:
// the first gets its src when the tile nears the viewport, the rest just before
// their turn, so no tile photo loads with the page. Cycling runs only while a
// tile is on screen and the tab is visible, pauses on hover/focus, and is off
// under prefers-reduced-motion (the first photo still loads and stays).
(() => {
  if (window.dtTileCycleLoaded) return;
  window.dtTileCycleLoaded = true;
  const still = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  const INTERVAL = 4000;
  const prime = img => {
    if (img.dataset.src) {
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      delete img.dataset.src; delete img.dataset.srcset;
    }
    return img.complete ? Promise.resolve() : new Promise(r => { img.onload = img.onerror = r; });
  };

  const setup = (box, index) => {
    const imgs = [...box.querySelectorAll('img.dt-tile__img')];
    if (!imgs.length || box.dataset.dtCycling) return;
    box.dataset.dtCycling = '1';
    const tile = box.closest('.dt-tile') || box;
    new IntersectionObserver((entries, io) => {
      if (entries[0].isIntersecting) { prime(imgs[0]); io.disconnect(); }
    }, { rootMargin: '300px' }).observe(tile);
    if (imgs.length < 2 || still) return;
    let i = 0, timer = null, visible = false, hovered = false;
    const step = async () => {
      const next = (i + 1) % imgs.length;
      await prime(imgs[next]);
      if (!visible || hovered || document.hidden) return schedule();
      imgs[i].classList.remove('is-on');
      imgs[next].classList.add('is-on');
      i = next;
      prime(imgs[(i + 1) % imgs.length]); // warm the one after, while this one shows
      schedule();
    };
    const schedule = () => { clearTimeout(timer); timer = setTimeout(step, INTERVAL); };
    const stop = () => { clearTimeout(timer); timer = null; };
    const start = () => { if (visible && !hovered && !timer) { timer = setTimeout(step, INTERVAL + (index % 4) * 700); } };
    tile.addEventListener('mouseenter', () => { hovered = true; stop(); });
    tile.addEventListener('mouseleave', () => { hovered = false; start(); });
    tile.addEventListener('focusin', () => { hovered = true; stop(); });
    tile.addEventListener('focusout', () => { hovered = false; start(); });
    new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      visible ? start() : stop();
    }, { rootMargin: '100px' }).observe(tile);
  };

  const run = () => document.querySelectorAll('[data-dt-tile-cycle]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
